import React from 'react';
import karbonSrc from 'images/karbon.png';
import { IntegrationModuleListItem } from 'components/Integrations/components/IntegrationModuleListItem';

export const KarbonIntegrationListItem = () => (
  <IntegrationModuleListItem iconSrc={karbonSrc} content="Karbon" />
);
